import NetworkUtils from "@/lib/network"
import {
  userDeviceTokenEndpoint,
  userPushStatusEndpoint,
} from "@/lib/endpoints"

export type PushStatus = {
  hasDeviceToken: boolean
}

export async function getPushStatus(): Promise<PushStatus> {
  return NetworkUtils.get<PushStatus>(userPushStatusEndpoint)
}

export async function registerDeviceToken(deviceToken: string): Promise<void> {
  await NetworkUtils.put<{ success: true }, { deviceToken: string }>(
    userDeviceTokenEndpoint,
    { deviceToken },
  )
}

export async function clearDeviceToken(): Promise<void> {
  await NetworkUtils.delete<{ success: true }>(userDeviceTokenEndpoint)
}
